import { render, staticRenderFns } from "./ParamOcorrencia.vue?vue&type=template&id=b7b0ae54"
import script from "./ParamOcorrencia.vue?vue&type=script&lang=js"
export * from "./ParamOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports